
import SiggImagePath from '../../assets/images/Sigg.png';

export function getSiggImagePath(): string {
   return SiggImagePath;
}